import type {IconName as UiIconName} from '@awesome.me/kit-4bfc2309f5/icons';
import type {IconName as TagIconName} from '@awesome.me/kit-1af7222dbb/icons';

export type IconName = UiIconName | TagIconName | 'notdef';

export type IconWeight = 'solid' | 'regular' | 'custom';

const WEIGHT_TO_PREFIX: Record<IconWeight, string> = {
    solid: 'fas',
    regular: 'far',
    custom: 'fak',
};

export function getPrefixByWeight(weight: IconWeight): string {
    return WEIGHT_TO_PREFIX[weight] ?? '';
}
